import script from "./NumberSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./NumberSpinner.vue?vue&type=style&index=0&id=661dd438&lang=scss"

const __exports__ = script;

export default __exports__